import { TableColumnType } from 'antd'
import moment from 'moment'
import React from 'react'
import { getMaterialsCategoryName } from '../../models/commodity'
import { DateTimeFormat } from '../../models/datetime'
import { Dimen } from '../../models/dimen'
import { getChrgitmLv, getListType, getPropPsnType } from '../../models/insurance'
import { getSupplierCategory } from '../../models/supplierCategory'

// 省目录列表
export const ProvinceColumns = (
  onclick: (id: number) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '目录名称',
      align: 'center',
      dataIndex: 'hilistName',
      width: '8rem',
      // sorter: (a, b) => {
      //   return a.regName.length - b.regName.length
      // },
    },
    {
      title: '中心编码',
      align: 'center',
      dataIndex: 'hilistCode',
      width: Dimen.Code,
    },
    {
      title: '开始日期',
      align: 'center',
      dataIndex: 'begndate',
      width: Dimen.Category,
    },
    {
      title: '结束日期',
      align: 'center',
      dataIndex: 'enddate',
      width: Dimen.Category,
    },
    {
      title: '甲乙丙分类',
      align: 'center',
      dataIndex: 'chrgitmLv',
      width: Dimen.Category,
      render: (_, t) => getChrgitmLv(t.chrgitmLv)
    },
    {
      title: '目录类别',
      align: 'center',
      dataIndex: 'listType',
      width: Dimen.Category,
      render: (_, t) => getListType(t.listType)
    },
  ]
}

// 自付比例列表
export const paymentRatioColumns = (
  onclick: (id: number) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },

    {
      title: '中心编码',
      align: 'center',
      dataIndex: 'hilistCode',
      width: '8rem',
    },
    {
      title: '人员类别',
      align: 'center',
      dataIndex: 'selfpayPropPsnType',
      width: '8rem',
      render: (_, t) => getPropPsnType(t.selfpayPropPsnType)
    },
    {
      title: '开始日期',
      align: 'center',
      dataIndex: 'begndate',
      width: Dimen.Category,
    },
    {
      title: '结束日期',
      align: 'center',
      dataIndex: 'enddate',
      width: Dimen.Category,
    },
    {
      title: '自付比例',
      align: 'center',
      dataIndex: 'selfpayProp',
      width: Dimen.Category,
    },
  ]
}

// 限价列表
export const LimitPriceColumns = (
  onclick: (id: number) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    // {
    //   title: '材料目录名称',
    //   align: 'center',
    //   dataIndex: 'hiGenname',
    //   width: '8rem',
    //   sorter: (a, b) => {
    //     return a.hiGenname.length - b.hiGenname.length
    //   },
    // },
    {
      title: '中心编码',
      align: 'center',
      dataIndex: 'hilistCode',
      width: '8rem',
    },
    {
      title: '限价金额',
      align: 'center',
      dataIndex: 'hilistPricUplmtAmt',
      width: Dimen.Category,
      render: (_, t) => {
        return Number(t.hilistPricUplmtAmt).toFixed(2)
      },
    },
    {
      title: '开始日期',
      align: 'center',
      dataIndex: 'begndate',
      key: 'begndate',
      width: Dimen.Category,
      ellipsis: true,
      render: (_, t) => {
        return moment(t.begndate).format(DateTimeFormat)
      },
    },
    {
      title: '结束日期',
      align: 'center',
      dataIndex: 'enddate',
      key: 'enddate',
      width: Dimen.Category,
      ellipsis: true,
      render: (_, t) => {
        return moment(t.enddate).format(DateTimeFormat)
      },
    },
  ]
}
